import api from 'app/actions/api';
import i18n from 'app/i18n';


export const TARIFFS_REQUEST = 'TARIFFS_REQUEST';
export const TARIFFS_SUCCESS = 'TARIFFS_SUCCESS';
export const TARIFFS_FAILURE = 'TARIFFS_FAILURE';

export const tariffsRequest = () => ({
  type: TARIFFS_REQUEST,
});

export const tariffsSuccess = data => ({
  type: TARIFFS_SUCCESS,
  payload: data,
});

export const tariffsFailure = errString => ({
  type: TARIFFS_FAILURE,
  payload: { err: errString },
});


/**
* Запрос данных по тарифам
*/
export const tariffsFetch = (service, studentId) => async (dispatch) => {
  const params = {
    service,
    student_id: studentId,
  };
  dispatch(tariffsRequest());
  try {
    const { data } = await api('cabinet/subscriptions/tariffs', 'get', { params });
    dispatch(tariffsSuccess(data));
  } catch (error) {
    dispatch(tariffsFailure(i18n.t('app:request_tariffs_failed')));
  }
};
